"use client";

import { useRouter } from "next/navigation";
import { RequireAuth } from "@/components/RequireAuth";
import { useAuth } from "@/contexts/AuthContext";
import { useIdleTimer } from "@/hooks/useIdleTimer";
import { LoggedInAppLayout } from "@/components/LoggedInAppLayout";
import { ActivePartnerProvider } from "@/contexts/ActivePartnerContext";
import ActivePartnerAnalyticsSync from "@/components/ActivePartnerAnalyticsSync";

function ProtectedShell({ children }: { children: React.ReactNode }) {
  const { logout } = useAuth();
  const router = useRouter();

  useIdleTimer(async () => {
    await logout();
    router.push("/login?reason=idle");
  });

  return <LoggedInAppLayout>{children}</LoggedInAppLayout>;
}

export default function ProtectedLayout({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <ActivePartnerProvider>
        <ActivePartnerAnalyticsSync />
        <ProtectedShell>{children}</ProtectedShell>
      </ActivePartnerProvider>
    </RequireAuth>
  );
}
